const AVALIACAO_SESSOES = {
  potencialidade_fiduciaria: {
    id: 'potencialidade_fiduciaria',
    label: 'Potencialidade fiduciária da gestora ',
    sessao: 'A',
    descricao:
      'As respostas aos quesitos deste grupo devem ser obtidas dos questionários de  due diligences recebidos de instituições gestoras / administradoras de fundos,  devidamente assinado por responsáveis técnicos e titular da área de  compliance ou de fontes independentes de informações.'
  },
  conflitos_asg: {
    id: 'conflitos_asg',
    label: 'Tratamento de conflitos e aspectos ASG ',
    sessao: 'B',
    descricao:
      'As respostas aos quesitos deste grupo devem ser obtidas dos questionários de  due diligences [DDQ] recebidos de instituições gestoras / administradoras de  fundos, devidamente assinados por responsáveis técnicos e titular da área de  compliance ou de fontes independentes de informações e/ou de sites oficiais de  CVM e outras instituições validadoras de certidões negativas.'
  },
  condicoes_regulamentares: {
    id: 'condicoes_regulamentares',
    label: 'Condições regulamentares dos fundos ',
    sessao: 'C',
    descricao:
      'As respostas aos quesitos deste grupo devem ser obtidas, exclusivamente, dos  regulamentos [incluindo apêndices e anexos] dos fundos, devidamente  cadastrados no site da Comissão de Valores Mobiliários – CVM.'
  }
};

export default AVALIACAO_SESSOES;
